import React, {Component} from 'react'
import {Configure, InstantSearch} from 'react-instantsearch-dom'
import algoliasearch from 'algoliasearch/lite'
import AlgoliaCollectionFilters from './filters'
import AlgoliaCollectionResults from './results'
import {ALGOLIA_COLLECTION_FILTER_RULES, API_KEY, APP_ID, getShopifyAlgoliaIndex, HITS_PER_RESULTS,} from '../config'
import {getUrlParameterByName} from '../../../modules/utils'
import qs from "qs"

const DEBOUNCE_TIME = 400
const createURL = (state) => `?${qs.stringify(state)}`
const searchStateToUrl = (location, searchState) => {
    return searchState ? `${location.pathname}${createURL(searchState)}` : ``
}
const urlToSearchState = (location) => qs.parse(location.search.slice(1))

export default class AlgoliaCollection extends Component {
    constructor(props) {
        super(props)

        /**
         * Set sort by index as default, else, display default country product index.
         */
        this.algoliaConfig = getShopifyAlgoliaIndex(this.props.algoliaIndex)
        this.sortByIndex = this.determineActiveFilterIndex()
        this.activeIndex = this.sortByIndex !== null ? this.sortByIndex : this.algoliaConfig.products

        this.state = {
            // @TODO remove anything associated with this results index. // previously 'products'
            resultsIndex: this.algoliaConfig.products,
            activeRefinements: 0,
            activeAlgoliaIndex: this.activeIndex,
            searchState: {}
        }

        this.setNavigationLevel = this.setNavigationLevel.bind(this)
        this.changeResultsIndex = this.changeResultsIndex.bind(this)

        const algoliaClient = algoliasearch(APP_ID, API_KEY)
        this.searchClient = {
            search(requests) {
                const newRequests = requests.map((request) => {
                    if(!request.params.query || request.params.query.length === 0) {
                        request.params.analytics = false
                    }
                    return request
                })
                return algoliaClient.search(newRequests)
            },
            // This enables filtering Facet Values in the refinementList widget
            searchForFacetValues: function (requests) {
                const newRequests = requests.map((request) => {
                    if(!request.params.query || request.params.query.length === 0) {
                        request.params.analytics = false
                    }
                    return request
                })
                return algoliaClient.searchForFacetValues(newRequests)
            },
        }
        this.setNumberRefinements = this.setNumberRefinements.bind(this)

        /**
         * Configure the Filters that need to be applied to the Collection -> Product Indexes
         */
        const {collection} = this.props
        this.configureFilters = this.getCollectionFilterRules(collection)
        this.configureFacetFilters = this.getFacetFilterRules(collection)

        this.onSearchStateChange = this.onSearchStateChange.bind(this)
    }

    determineActiveFilterIndex() {
        const activeSortingIndex = getUrlParameterByName(`sort`)
        if (activeSortingIndex) {
            const algoliaSortingOptions = this.algoliaConfig.sortOptions
            const index = algoliaSortingOptions.findIndex(option => option.label === activeSortingIndex)
            return algoliaSortingOptions[index].value
        } else {
            return null
        }
    }

    createMarkup(value) {
        return {__html: value}
    }

    setNumberRefinements(number) {
        this.setState({
            activeRefinements: number,
        })
    }

    setNavigationLevel(level) {
        this.setState({
            navigationLevel: level,
        })
    }

    changeResultsIndex(index) {
        this.setState({
            resultsIndex: index,
        })
    }

    openFilters() {
        const element = document.getElementById(`sidebar-content`)
        if (element.classList.contains(`sidebar-mobile-view`)) {
            element.classList.remove(`sidebar-mobile-view`)
        } else {
            element.classList.add(`sidebar-mobile-view`)
        }
    }

    getCollectionFilterRules(collection) {
        let algoliaFilterRules = ``
        let algoliaTagFilterRules = ` AND ${ALGOLIA_COLLECTION_FILTER_RULES}`
        const isValidCollection = collection && collection.handle
        const isProductCollectionView = collection

        const appendAlgoliaFilterRules = (rule) => algoliaFilterRules += rule

        if (isValidCollection) {
            appendAlgoliaFilterRules(`collections:"${collection.handle}"`)
        }

        if (isValidCollection && isProductCollectionView) {
            appendAlgoliaFilterRules(algoliaTagFilterRules)
        }

        return algoliaFilterRules
    }

    getFacetFilterRules() {
        const getAppliedTags = () => {
            const collectionJsonScript = window.document.querySelector(`#CollectionJson`)

            if (!collectionJsonScript) return []

            const collectionJson =  JSON.parse(collectionJsonScript.textContent)
            const currentTags = collectionJson.current_tag

            // return empty array for blank tags or return the tags
            return (currentTags === `blank`) ? [] : currentTags
        }

        const currentTags = getAppliedTags()

        if (!currentTags.length) return ``

        // Convert currentTags into string ready for Algolia
        const rulesArray = currentTags.map(tag => `"named_tags.${tag}"`)
        const rulesString = `[[${rulesArray.toString()}]]`

        return rulesString
    }

    onSearchStateChange(searchState) {
        clearTimeout(this.debouncedSetState)

        this.debouncedSetState = setTimeout(() => {
            window.history.pushState(
                this.state.searchState,
                null,
                searchStateToUrl(window.location, searchState)
            )
        }, DEBOUNCE_TIME)

        this.setState({searchState})
    }

    async componentDidMount() {
        this.setState({
            searchState: qs.parse(window.location.search.slice(1)),
        })
    }


    render() {
        const {collection, collections, navigation} = this.props
        const {activeAlgoliaIndex} = this.state

        return (
            <div>
                <InstantSearch
                    indexName={activeAlgoliaIndex}
                    searchClient={this.searchClient}
                    searchState={this.state.searchState}
                    onSearchStateChange={this.onSearchStateChange}
                    createURL={createURL}
                >
                    <Configure
                        filters={`${this.configureFilters}`}
                        facetFilters={`${this.configureFacetFilters}`}
                        hitsPerPage={HITS_PER_RESULTS}
                        distinct
                    />
                    <div className="breadcrumbs small-show">
                        <div className="breadcrumb-items">
                            <a href={collection.handle}>{collection.title}</a>
                        </div>
                    </div>
                    <div className="main xlarge flex column">
                        <div
                            id="sidebar-content"
                            className="sidebar sidebar-mobile-view"
                        >
                            <div id="filterContainer">
                                <AlgoliaCollectionFilters
                                    collection={this.props.collection}
                                    collections={this.props.collections}
                                    country={this.props.country}
                                    navigationLevel={this.state.navigationLevel}
                                    changeResultsIndex={this.changeResultsIndex}
                                    setNumberRefinements={this.setNumberRefinements}
                                    refinementCount={this.state.activeRefinements}
                                    activeAlgoliaIndex={activeAlgoliaIndex}
                                    enableSearchedFacets={true}
                                    algoliaConfig={this.algoliaConfig}
                                />
                            </div>
                            <div className="flex v-center h-center back-button-wrapper">
                                <button
                                    className="back-button small-show"
                                    onClick={e => this.openFilters()}
                                >
                                    Apply Filters
                                </button>
                            </div>
                        </div>
                        <div className="listing-panel coluimn column-9 small-12">
                            <div className="body-component column column-12">
                                <div id="resultsContainer">
                                    <AlgoliaCollectionResults
                                        collection={this.props.collection}
                                        collections={this.props.collections}
                                        country={this.props.country}
                                        changeResultsIndex={this.changeResultsIndex}
                                        resultsIndex={this.state.resultsIndex}
                                        refinementCount={this.state.activeRefinements}
                                        activeAlgoliaIndex={activeAlgoliaIndex}
                                        algoliaConfig={this.algoliaConfig}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </InstantSearch>
            </div>
        )
    }
}
